import { Observable } from 'rxjs';
import { CanActivateFn } from '@angular/router';
import { InjectionToken } from '@angular/core';

import { AuthService, ResetPasswordFn } from './auth.types';

import { Role, WoPermission } from '@iss/libs/graphql';

export const WO_PROTECTED_RESOURCES = new InjectionToken<readonly string[]>('WO_PROTECTED_RESOURCES');
export const WO_USER_ROLES = new InjectionToken<Observable<Set<Role>>>('WO_USER_ROLES');
export const WO_USER_PERMISSIONS = new InjectionToken<Observable<Set<WoPermission>>>('WO_USER_PERMISSIONS');
export const ISS_AUTH_SERVICE = new InjectionToken<AuthService>('ISS_AUTH_SERVICE');
export const ISS_AUTH_GUARD = new InjectionToken<CanActivateFn>('ISS_AUTH_GUARD');
export const ISS_RESET_PASSWORD = new InjectionToken<ResetPasswordFn | undefined>('ISS_RESET_PASSWORD_FN');
export const ISS_REDIRECT_URI = new InjectionToken<string>('ISS_REDIRECT_URI');
export const ISS_LOGOUT_URI = new InjectionToken<string>('ISS_LOGOUT_URI');
export const ISS_HOST_URI = new InjectionToken<string>('ISS_HOST_URI');
